import { supabase } from "@/integrations/supabase/client";

export interface RoomChatMessage {
  id: string;
  room_id: string;
  user_id: string;
  role: string;
  message: string;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

export async function loadRoomChatMessages(roomId: string): Promise<RoomChatMessage[]> {
  const { data, error } = await (supabase as any)
    .from("room_chat_messages")
    .select("*")
    .eq("room_id", roomId)
    .order("created_at", { ascending: true });

  if (error) {
    console.error("Error loading room chat messages:", error);
    return [];
  }

  return data as RoomChatMessage[];
}

export async function saveRoomChatMessage({
  roomId,
  role,
  message,
  metadata = {},
}: {
  roomId: string;
  role: "user" | "assistant";
  message: string;
  metadata?: Record<string, unknown>;
}): Promise<RoomChatMessage | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await (supabase as any)
    .from("room_chat_messages")
    .insert({
      room_id: roomId,
      user_id: user.id,
      role,
      message,
      metadata,
    })
    .select("*")
    .single();

  if (error) {
    console.error("Error saving room chat message:", error);
    return null;
  }

  return data as RoomChatMessage;
}

export async function clearRoomChatMessages(roomId: string): Promise<boolean> {
  const { error } = await (supabase as any)
    .from("room_chat_messages")
    .delete()
    .eq("room_id", roomId);

  if (error) {
    console.error("Error clearing room chat messages:", error);
    return false;
  }

  return true;
}
